import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import urlConsts from "./../../constants/urls";
import Footer from "./../../containers/FooterContainer";
import Confirmation from "./../commonComponents/confirmationBox";
import getLabel from './../../utils/labels'
import gif1 from "./../../globals/images/attend.gif";
import gif2 from "./../../globals/images/accept.gif";
import gif3 from "./../../globals/images/Timer.gif";
import SimLogo from "./../UiComponents/Logo";
import bgImage from "./../../globals/images/intro-bg.png";
import styles from "./tutorialEndScreen.module.scss";
import analyticsUtil from "../../utils/segmentUtils";

class TutorialEndScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isConfirmationOpen: false
        };
    }

    componentDidMount = () => {
        this.props.endTutorial();
        analyticsUtil.page('Tutorial end page')
    };

    openConfirmationBox = () => {
        this.setState({
            isConfirmationOpen: true
        });
    };

    closeConfirmationBox = () => {
        this.setState({
            isConfirmationOpen: false
        });
    };

    startSimulation = () => {
        window.location.href = window.location.href.split('/').slice(0, -1).join('/mails/');
    }

    logout = () => {
        let logoutUrl = (this.props.logoutType === 'NORMAL') ? urlConsts.LOGOUT_URL : urlConsts.RETURN_URL
        analyticsUtil.reset()
        window.location = logoutUrl
    };

    render() {
        let { isConfirmationOpen } = this.state;
        let { introductionData } = this.props;
        let nextUrl = "/mails",
            tutorialUrl = "/tutorial";

        let logoutButtonText = (this.props.logoutType === 'NORMAL') ? getLabel('label_logout_button') : getLabel('label_return_button')
        let logoutConfirmation = (this.props.logoutType === 'NORMAL') ? getLabel('label_logout_confirmation') : getLabel('label_return_confirmation');

        let objective1 = introductionData.step3.gif1 ? introductionData.step3.gif1 : gif1;
        let objective2 = introductionData.step3.gif2 ? introductionData.step3.gif2 : gif2;
        let objective3 = introductionData.step3.gif3 ? introductionData.step3.gif3 : gif3;

        return (
            <Fragment>
                <div
                    className={styles["intro-container"]}
                    style={{ backgroundImage: `url(${bgImage})` }}
                >
                    <div className={styles["title-container"]}>
                        <div className={styles.title}>
                            <SimLogo />
                        </div>
                        <div className={styles["right-content-container"]}>
                            <p
                                className={styles.logout}
                                onClick={this.openConfirmationBox}
                            >
                                {
                                    (this.props.logoutType === 'NORMAL')
                                        ? 'LOGOUT'
                                        : 'RETURN'
                                }
                            </p>
                        </div>
                    </div>
                    <div className={styles["tutorial-end-container"]}>
                        <div className={styles["objectives-container"]}>
                            <div className={styles["gif-container"]}>
                                <div>
                                    {introductionData.tutorialEndPage.recapObjectivesText}
                                </div>
                                <div className={styles.gifs}>
                                    <div className={styles["gif-item"]}>
                                        <div className={styles["gif"]}>
                                            <img src={objective1} />
                                        </div>
                                        <div className={styles["gif-text"]}>
                                            {introductionData.step3.info1}
                                        </div>
                                    </div>
                                    <div className={styles["gif-item"]}>
                                        <div className={styles["gif"]}>
                                            <img src={objective2} />
                                        </div>
                                        <div className={styles["gif-text"]}>
                                            {introductionData.step3.info2}
                                        </div>
                                    </div>
                                    <div className={styles["gif-item"]}>
                                        <div className={styles["gif"]}>
                                            <img src={objective3} />
                                        </div>
                                        <div className={styles["gif-text"]}>
                                            {introductionData.step3.info3}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.buttons}>
                            <Link
                                to={tutorialUrl}
                                onClick={this.props.restartTutorial}
                            >
                                <div
                                    className={styles["replay-tutorial-button"]}
                                >
                                    <div className={styles["button-text"]}>
                                        {getLabel('label_replay_tutorial_button')}
                                    </div>
                                </div>
                            </Link>
                            <div style={{ width: "10px" }} />
                            <Link
                                to={nextUrl}
                            // onClick={this.startSimulation}
                            >
                                <div className={styles["start-sim-button"]}>
                                    <div className={styles["button-text"]}>
                                        {getLabel('label_start_simulation_button')}{" "}
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>

                    <Footer isIntro={true} />
                </div>
                {isConfirmationOpen ? (
                    <Confirmation
                        acceptButtonText={logoutButtonText}
                        confimationMessage={logoutConfirmation}
                        onAcceptClick={this.logout}
                        onCancelClick={this.closeConfirmationBox}
                    />
                ) : null}
            </Fragment>
        );
    }
}

export default TutorialEndScreen;



// WEBPACK FOOTER //
// /src/components/tutorialEndScreen/TutorialEndScreen.js